import { FC } from 'react';

type HintProps = {
  label?: string;
  icon?: string;
  type?: 'positive' | 'negative' | 'module-color' | 'warning';
  size?: string;
  clean?: boolean;
  className?: string;
  top?: boolean;
  left?: boolean;
};

const Hint: FC<HintProps> = ({
  label,
  icon = 'fa-times-circle',
  children,
  type = 'positive',
  size = 'md',
  clean = true,
  className = '',
  top = false,
  left = false
}) => {
  const transform = [
    top ? 'translateY(-100%)' : '',
    left ? 'translateX(calc(-100% - 3em))' : ''
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      {label && <label className="label">{label}</label>}
      <div
        className={`hint ${icon} ${type} ${size} ${
          clean ? 'clean' : ''
        } ${className}`}
      >
        <div className="hint-content" style={{ transform }}>
          {children}
        </div>
      </div>
    </>
  );
};

export { Hint };
